import type { TBatchAddTargetKey } from '../types';
import type { IColumnRawInfo } from '@dbl/core/dataSource';

/**
 * 字段本身是否为敏感字段。
 * attribute=8 与 column_sensitive 接口可能只返回其一，需同时判断。
 */
const isSensitiveField = (field: IColumnRawInfo): boolean =>
  field.column_sensitive === true || field.attribute === 8;

/**
 * 当前落区是否禁止加入敏感字段（与 dragOnMove 一致）。
 *
 * @returns true 表示该 targetKey 下敏感字段应 disable / 不可批量写入
 *
 * 口径说明：
 * - columnFilters / columnDimensions / columnX / columnShowDimensions：禁止敏感字段
 * - columnMetrics / columnRawColumns：指标与原始列允许敏感字段，不在此拦截
 */
export const isSensitiveFieldBlocked = (
  targetKey: TBatchAddTargetKey,
  field: IColumnRawInfo,
): boolean =>
  (targetKey === 'columnFilters' ||
    targetKey === 'columnDimensions' ||
    targetKey === 'columnX' ||
    targetKey === 'columnShowDimensions') &&
  isSensitiveField(field);
